export const LOGIN_REQUESTING = 'LOGIN_REQUESTING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_UNSUCCESS = 'LOGIN_UNSUCCESS';
export const LOGOUT_REQUESTING = 'LOGOUT_REQUESTING';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL';